import "./Policy.css";
import { useTranslation } from "react-i18next";
import { PRICING_OPEN } from "../../config/features";

export default function ServiceInfoPage() {
  const { t } = useTranslation();

  return (
    <div className="policy-container">
      <h1>{t("service_guide")}</h1>

      <p>
        {t("policy.service.intro")}
      </p>

      <h2>{t("policy.service.section1.title")}</h2>

      <ul>
        <li>{t("policy.service.section1.items.upload")}</li>
        <li>{t("policy.service.section1.items.download")}</li>
      </ul>

      <h2>{t("policy.service.section2.title")}</h2>

      <ul>
        <li>{t("policy.service.section2.items.formats")}</li>
        <li>{t("policy.service.section2.items.share")}</li>
        <li>{t("policy.service.section2.items.responsibility")}</li>
      </ul>

      <h2>{t("policy.service.section3.title")}</h2>

      <ul>
        <li>{t("policy.service.section3.items.browse")}</li>
        <li>{t("policy.service.section3.items.use")}</li>
      </ul>

      {PRICING_OPEN ? (
        <>
          <h2>{t("policy.service.section4.title")}</h2>

          <p>
            {t("policy.service.section4.p1")}
          </p>

          <ul>
            <li>{t("policy.service.section4.items.plan")}</li>
            <li>{t("policy.service.section4.items.payment")}</li>
          </ul>
        </>
      ) : (
        <>
          <h2>{t("policy.service.section4.title_free")}</h2>

          <p>{t("policy.service.section4.p1_free")}</p>

          <ul>
            <li>{t("policy.terms.section5.free_items.download")}</li>
            <li>{t("policy.terms.section5.free_items.ai")}</li>
            <li>{t("policy.terms.section5.free_items.storage")}</li>
            <li>{t("policy.terms.section5.free_items.trash")}</li>
          </ul>
        </>
      )}

      <h2>{t("policy.service.section5.title")}</h2>

      <ul>
        <li>{t("policy.service.section5.items.ip")}</li>
        <li>{t("policy.service.section5.items.illegal")}</li>
        <li>{t("policy.service.section5.items.interrupt")}</li>
      </ul>

      <h2>{t("policy.service.section6.title")}</h2>

      <p>
        {t("policy.service.section6.p1")}
      </p>

      <p>
        {t("policy.service.section6.p2")}
      </p>

      <h2>{t("policy.service.section7.title")}</h2>

      <p>{t("policy.service.section7.p1")}</p>

      <p>3d@makerz.co.kr</p>
    </div>
  );
}